import type { JSX } from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { SortableTableHeaders } from '@/shared/components/SortableTableHeaders';
import type { SortState } from '@/shared/types/table-filters.types';
import { VerificationTableRow } from './VerificationTableRow';
import type { Verification } from '../types/verification.types';

interface VerificationTableProps {
  verifications: Verification[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onDelete: (id: string) => void;
  onCopyRefereeLink: (verificationId: string, shareId: string) => void;
}

const SORTABLE_HEADERS = [
  { key: 'refereeName', label: 'Reference contact name' },
  { key: 'refereeEmail', label: 'Email' },
  { key: 'refereeJobTitle', label: 'Job Title' },
  { key: 'status', label: 'Status' },
];

export function VerificationTable({
  verifications,
  sort,
  onToggleSort,
  onDelete,
  onCopyRefereeLink,
}: VerificationTableProps): JSX.Element {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <SortableTableHeaders
            headers={SORTABLE_HEADERS}
            sort={sort}
            onToggleSort={onToggleSort}
          />
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {verifications.map((verification) => (
          <VerificationTableRow
            key={verification.id}
            verification={verification}
            onDelete={() => onDelete(verification.id)}
            onCopyRefereeLink={() => onCopyRefereeLink(verification.id, verification.shareId)}
          />
        ))}
      </TableBody>
    </Table>
  );
}
